export default __webpack_public_path__ + "static/media/T2_UT_W.f88cf200.png";